export default __webpack_public_path__ + "static/media/1.a97c34d2.png";